"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { cn } from "@/lib/utils";
export default function BerbrCkungWissenschaftTrifftTradition() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const badges = [{
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1629163/img/hypnosystemic_coaching_icon.png",
    alt: "Hypnosystemisches Coaching",
    className: "h-12 md:h-16 object-contain"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1629163/img/tai_chi_qi_gong_symbol.png",
    alt: "Tai Chi & Qi Gong",
    className: "h-16 md:h-24 object-contain"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1629163/img/yoga_vipassana_meditation.png",
    alt: "Yoga & Vipassana",
    className: "h-12 md:h-16 object-contain"
  }];
  return;
}